/**
 * @generated SignedSource<<62d049cacbc34d22570744ea2ed47c1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type FreelancerProfile_User$data = {
  readonly id: string;
  readonly profile: {
    readonly openToOpportunities: boolean | null | undefined;
  } | null | undefined;
  readonly self: boolean | null | undefined;
  readonly status: UserStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Summary_UserProfile" | "TimelineEntriesField_User" | "UserSkillsFields_User" | "VideoAnswersField_User" | "VideoField_User">;
  readonly " $fragmentType": "FreelancerProfile_User";
};
export type FreelancerProfile_User$key = {
  readonly " $data"?: FreelancerProfile_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"FreelancerProfile_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FreelancerProfile_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "self",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "openToOpportunities",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Summary_UserProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimelineEntriesField_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserSkillsFields_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VideoField_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VideoAnswersField_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6e09cc94734553bc32f07619eefcbfe1";

export default node;
